import { render, staticRenderFns } from "./VForm.vue?vue&type=template&id=6ae8cd74&"
import script from "./VForm.vue?vue&type=script&lang=js&"
export * from "./VForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae8cd74')) {
      api.createRecord('6ae8cd74', component.options)
    } else {
      api.reload('6ae8cd74', component.options)
    }
    module.hot.accept("./VForm.vue?vue&type=template&id=6ae8cd74&", function () {
      api.rerender('6ae8cd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VForm.vue"
export default component.exports